import React from 'react';
import Layout from '../components/Layout';
import Section from '../components/Section';
import { Container, Row, Column } from '../components/Grid';
import Image from '../components/Image';
import PageBanner from '../components/PageBanner';
import AboutPartners from '../components/AboutPartners';
import Button from '../components/Button';
import './resources.scss';

const PartnersPage = () => (
  <Layout title="USCSF Resources">
    <PageBanner title="USCSF Resources" />

    {/* ── More from USC Shoah Foundation ───────────────────────── */}
    <Section className="partners-section">
      <Container>
        <h2 className="partners-group-heading">More from USC Shoah Foundation</h2>

        {/* Mindful Explorations */}
        <Row className="partners-resource-row">
          <Column size={5} className="partners-resource-image-col">
            <Image filename="SHOAH-Partners-MindfulExplorations-feature.png" alt="Mindful Explorations" />
          </Column>
          <Column size={7} className="partners-resource-content-col">
            <h3 className="partners-resource-title">Mindful Explorations</h3>
            <p>These brief, 10-minute activities use the connective power of testimony to cultivate social-emotional skills that help students cope with challenges, build positive relationships, and make informed decisions that can help them counter hatred wherever they see it.</p>
            <Button to="https://iwitness.usc.edu/sites/mindfulexplorations" target="_blank" rel="noopener noreferrer" aria-label="Learn More about Mindful Explorations">Learn More</Button>
          </Column>
        </Row>
      </Container>
    </Section>

    {/* ── The Willesden Project ─────────────────────────────────── */}
    <Section className="partners-section">
      <Container>
        <h2 className="partners-group-heading">The Willesden Project</h2>
        <p className="partners-group-description">The Willesden Project brings the power of music and story to reach young people globally and contribute to their development as empathetic, knowledgeable and resilient individuals.</p>

        {/* Primary School */}
        <Row className="partners-resource-row">
          <Column size={5} className="partners-resource-image-col">
            <Image filename="SHOAH-Partners-WillesdenPrimary-feature.png" alt="The Willesden Project Primary School" />
          </Column>
          <Column size={7} className="partners-resource-content-col">
            <h3 className="partners-resource-title">The Willesden Project Primary School</h3>
            <p>Explore transformative activities for K-5 students such as innovative interactive biographies with Holocaust survivors, the animated short film Music Dreams, and the digital book, Art in My Heart: The Stories of Mona, Lual, and Arpi.</p>
            <Button to="https://iwitness.usc.edu/sites/TWP_Primary" target="_blank" rel="noopener noreferrer" aria-label="Learn More about The Willesden Project Primary School">Learn More</Button>
          </Column>
        </Row>

        {/* Middle School */}
        <Row className="partners-resource-row">
          <Column size={5} className="partners-resource-image-col">
            <Image filename="SHOAH-Partners-WillesdenMiddle-feature.png" alt="The Willesden Project Middle School" />
          </Column>
          <Column size={7} className="partners-resource-content-col">
            <h3 className="partners-resource-title">The Willesden Project Middle School</h3>
            <p>Discover classroom materials for grades 6-8 such as a virtual field trip, Making a New Life: The Courage of a Refugee, interactive biographies, and teacher guides to enhance learning of the book, The Children of Willesden Lane.</p>
            <Button to="https://iwitness.usc.edu/sites/TWP_Middle" target="_blank" rel="noopener noreferrer" aria-label="Learn More about The Willesden Project Middle School">Learn More</Button>
          </Column>
        </Row>

        {/* High School */}
        <Row className="partners-resource-row">
          <Column size={5} className="partners-resource-image-col">
            <Image filename="SHOAH-Partners-WillesdenHigh-feature.png" alt="The Willesden Project High School" />
          </Column>
          <Column size={7} className="partners-resource-content-col">
            <h3 className="partners-resource-title">The Willesden Project High School</h3>
            <p>Find resources for high school students such as a Virtual IWalk to follow the footsteps of Lisa Jura, a Holocaust survivor, interactive biographies, and more innovative digital activities.</p>
            <Button to="https://iwitness.usc.edu/sites/TWP_High" target="_blank" rel="noopener noreferrer" aria-label="Learn More about The Willesden Project High School">Learn More</Button>
          </Column>
        </Row>

      </Container>
    </Section>

    {/* ── About the Partners ────────────────────────────────────── */}
    <AboutPartners />

  </Layout>
);

export default PartnersPage;
